import { createAction, props } from '@ngrx/store';
import { CreateProgramSessionDto, ProgramSessionDto, UpdateProgramSessionDto } from '@shared/dto';

// Load
export const readProgramSessions = createAction('@app/program-session/read', props<{ programId: number }>());
export const readProgramSessionsSuccess = createAction('@app/program-session/read/success', props<{ data: ProgramSessionDto[] }>());
export const readProgramSessionsFailure = createAction('@app/program-session/read/failure', props<{ error: any }>());

// Create
export const createProgramSession = createAction('@app/program-session/create', props<{ programId: number; dto: CreateProgramSessionDto }>());
export const createProgramSessionSuccess = createAction('@app/program-session/create/success', props<{ session: ProgramSessionDto }>());
export const createProgramSessionFailure = createAction('@app/program-session/create/failure', props<{ error: any }>());

// Update
export const updateProgramSession = createAction('@app/program-session/update', props<{ programId: number; sessionId: number; dto: UpdateProgramSessionDto }>());
export const updateProgramSessionSuccess = createAction('@app/program-session/update/success', props<{ session: Partial<ProgramSessionDto> }>());
export const updateProgramSessionFailure = createAction('@app/program-session/update/failure', props<{ error: any }>());

// Delete
export const deleteProgramSession = createAction('@app/program-session/delete', props<{ programId: number; sessionId: number }>());
export const deleteProgramSessionSuccess = createAction('@app/program-session/delete/success', props<{ session: ProgramSessionDto }>());
export const deleteProgramSessionFailure = createAction('@app/program-session/delete/failure', props<{ error: any }>());

// Restore
export const restoreProgramSession = createAction('@app/program-session/restore', props<{ programId: number; sessionId: number }>());
export const restoreProgramSessionSuccess = createAction('@app/program-session/restore/success', props<{ session: ProgramSessionDto }>());
export const restoreProgramSessionFailure = createAction('@app/program-session/restore/failure', props<{ error: any }>());
